import {
  BundleConfig,
  TapConfig,
  VariableConfig,
} from '@iotize/tap/config/schema/v1';

export class TapConfigProvider {
  private config: TapConfig = {
    version: '1.0.0',
  };

  get bundles(): BundleConfig[] {
    return this.config.data?.bundles || [];
  }

  get variables(): VariableConfig[] {
    return this.bundles.reduce((p, bundle) => {
      p.push(...(bundle.variables || []));
      return p;
    }, [] as VariableConfig[]);
  }
}
